import { AnimationManager, MotionSymbol } from 'feature-motion'
import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol, BrowserWindowSymbol, pageIdSym, ReducedMotionSymbol } from '@wix/thunderbolt-symbols'
import type { ICanvas, CanvasFactory } from './types'
import { name as featureName } from './symbols'
import { CanvasManager } from './CanvasManager'
import { initCustomElement } from '@wix/canvas'
import { isSSR } from '@wix/thunderbolt-commons'
import contextManager from './contextManager'

const canvasFactory: CanvasFactory = (featureConfig, browserWindow, pageId, reducedMotion, motion?): ICanvas => {
	const { animationDataByCompId, scrubTriggers, canvasBpRanges } = featureConfig

	if (isSSR(browserWindow) || reducedMotion) {
		return {
			name: 'canvas',
			async pageWillMount() {},
			async pageDidMount() {},
			async pageWillUnmount() {},
		}
	}

	let _contextManager = contextManager

	if (browserWindow.__wixWebGLContextManager__) {
		_contextManager = browserWindow.__wixWebGLContextManager__
	} else {
		browserWindow.__wixWebGLContextManager__ = contextManager
	}

	// TODO - if no animationManager then return nothing? maybe get it in pageDidMount?
	const animationManager: AnimationManager | undefined = motion!.getManager()

	const canvasManager: CanvasManager = new CanvasManager(browserWindow!)

	return {
		name: 'canvas',
		async pageWillMount() {
			pageReadyPromise = new Promise<void>((resolve) => {
				setReady = resolve
			})
		},
		async pageDidMount() {
			canvasManager.init(animationManager!, animationDataByCompId, scrubTriggers, canvasBpRanges)

			if (!didInit) {
				didInit = true
				if (browserWindow && (browserWindow as typeof window).customElements) {
					initCustomElement({ getPageReady, contextManager: _contextManager }, browserWindow as typeof window)
				}
			}

			setReady()
		},
		async pageWillUnmount() {
			canvasManager.destroy()
		},
	}
}

let setReady: () => void, pageReadyPromise: Promise<void>
let didInit = false

function getPageReady() {
	return pageReadyPromise
}

export const Canvas = withDependencies(
	[
		named(PageFeatureConfigSymbol, featureName),
		BrowserWindowSymbol,
		pageIdSym,
		ReducedMotionSymbol,
		optional(MotionSymbol),
	],
	canvasFactory
)
